import * as React from "react";
import { UserRecordCounters } from "models/ApiModels";
import { IRecordAboutProps, RecordAbout } from "components/RecordAbout";
import { TextPluralization } from "components/TextPluralization";
import { Formaters } from "lib/Formarters";

interface IProps extends IRecordAboutProps {
    counters: UserRecordCounters;
    lastAccess: Date;
}

export const WidgetUserAbout: React.FC<IProps> = (props) => {
    return (
        <RecordAbout
            {...props}
            otherInfo={
                <>
                    <br />
                    {props.lastAccess && <span>Último Acesso: {Formaters.relativeCalendar(props.lastAccess)} <br /> </span>}
                    <span>Possui {props.counters.publications} <TextPluralization count={props.counters.publications} singular="publicação" plural="publicações" /></span>
                    <br />
                    <span>Possui {props.counters.followers} <TextPluralization count={props.counters.followers} singular="seguidor" plural="seguidores" /></span>
                </>
            }
        />
    );
}
